import React from "react";
import useEditUserForm, { EditUserFormProps } from "./useEditUserForm";
import UserForm from "../UserForm";
import ChangePasswordModal from "./ChangePasswordModal";
import LoadingSpinner from "../../Common/LoadingSpinner";

function EditUserForm(props: EditUserFormProps) {
    const pageContent = useEditUserForm(props);

    if (pageContent.isLoading) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <UserForm
                resources={props.resources}
                departmentRoleOptions={props.departmentRoleOptions}
                formState={pageContent.formState}
                showNewCompanyInputs={pageContent.showNewCompanyInputs}
                showNewCompanyDepartmentInput={pageContent.showNewCompanyDepartmentInput}
                showNewUserRoleRow={pageContent.showNewUserRoleRow}
                companyOptions={pageContent.companyOptions}
                companyDepartmentOptions={pageContent.companyDepartmentOptions}
                submitButtonText={props.resources.get("SaveChanges") ?? ""}
                onFirstNameChange={pageContent.handleFirstNameChange}
                onLastNameChange={pageContent.handleLastNameChange}
                onEmailChange={pageContent.handleEmailChange}
                onPhoneNumberChange={pageContent.handlePhoneNumberChange}
                onReceivesSmsChange={pageContent.handleReceivesSmsChange}
                onNewCompanyNameChange={pageContent.handleNewCompanyNameChange}
                onNewCompanyDepartmentNameChange={pageContent.handleNewDepartmentNameChange}
                onRoleRemoved={pageContent.handleRoleRemoved}
                onHideNewCompanyInputs={pageContent.handleHideNewCompanyInputs}
                onHideNewCompanyDepartmentInput={pageContent.handleHideNewCompanyDepartmentInput}
                onRoleAdded={pageContent.handleNewRoleAdded}
                onShowNewCompanyInputs={pageContent.handleShowNewCompanyInputs}
                onShowNewCompanyDepartmentInput={pageContent.handleShowNewCompanyDepartmentInput}
                onHideNewUserRoleRow={pageContent.handleHideNewUserRoleRow}
                onShowNewUserRoleRow={pageContent.handleShowNewUserRoleRow}
                onCompanySearch={pageContent.handleCompanySearchAsync}
                onCompanySelected={pageContent.handleCompanySelected}
                onCompanyRemoved={pageContent.handleCompanyRemoved}
                onCompanyDepartmentRemoved={pageContent.handleCompanyDepartmentRemoved}
                onCompanyDepartmentSelected={pageContent.handleCompanyDepartmentSelected}
                onSubmit={pageContent.handleSubmitAsync}
                onChangePasswordClick={pageContent.canEditPassword ? pageContent.handleShowChangePasswordModal : undefined}
            />
            <ChangePasswordModal
                show={pageContent.showChangePasswordModal}
                userId={props.userId}
                resources={props.resources}
                onPasswordUpdated={pageContent.handlePasswordUpdated}
                onHide={pageContent.handleHideChangePasswordModal}
            />
        </>
    );
}

export default EditUserForm;
export type { EditUserFormProps };
